 const constants={
    web_general:"Webchat non-GPT backup",
    voice_general:"Voice bot non-GPT backup",
    GEN_WEB:"Webchat non-GPT backup",
    GEN_VOICE:"Voice bot non-GPT backup"
}
export default constants;